import { createSlice } from "@reduxjs/toolkit";
import { SubscriptionsState } from "../entities/interfaces/subscriptions-state.interface";
import getSubscriptionsCases from "./cases/get-subscriptions.cases";

const initialState: SubscriptionsState = {
  subscriptions: [],
  isLoadingSubscriptions: false
};

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getSubscriptionsCases(builder);
  }
});

export default subscriptionsSlice.reducer;
